// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_DATA = "SET_DATA";
export const SET_AUTH = "SET_AUTH";
export const SET_NEW_PROJECT = "SET_NEW_PROJECT";
export const SET_VERIFICATION_DOCUMENT = "SET_VERIFICATION_DOCUMENT";
export const SET_COVER_IMAGE = "SET_COVER_IMAGE";
export const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";
